const preserveRowsMeta = (nextRows, sourceRows) => {
  if (Array.isArray(sourceRows) && sourceRows.meta) {
    Object.defineProperty(nextRows, 'meta', {
      value: sourceRows.meta,
      enumerable: false,
      configurable: true,
    });
  }
  return nextRows;
};

const varianceIdentityMatches = (row = {}, saved = {}, variables = {}) => {
  const savedId = saved.id || saved.varianceId || saved.variance_id || variables.varianceId;
  if (savedId && [row.id, row.varianceId, row.variance_id].filter(Boolean).some((id) => String(id) === String(savedId))) return true;
  return Boolean(variables.bac && row.bac && String(row.bac) === String(variables.bac));
};

const reviewedValue = (saved = {}, variables = {}) => {
  if (Object.prototype.hasOwnProperty.call(saved, 'reviewed')) return Boolean(saved.reviewed);
  if (Object.prototype.hasOwnProperty.call(variables.patch || {}, 'reviewed')) return Boolean(variables.patch.reviewed);
  return undefined;
};

const patchVarianceReviewRow = (row = {}, saved = {}, variables = {}) => {
  if (!varianceIdentityMatches(row, saved, variables)) return row;
  const reviewed = reviewedValue(saved, variables);
  return {
    ...row,
    ...(reviewed === undefined ? {} : { reviewed }),
    reviewDriver: saved.reviewDriver ?? saved.review_driver ?? variables.patch?.reviewDriver ?? row.reviewDriver,
    remediation: saved.remediation ?? variables.patch?.remediation ?? row.remediation,
    updatedAt: saved.updatedAt || saved.updated_at || row.updatedAt,
    review: {
      ...(row.review || {}),
      ...(reviewed === undefined ? {} : { reviewed }),
      category: saved.reviewDriver ?? saved.review_driver ?? variables.patch?.reviewDriver ?? row.review?.category,
      remediation: saved.remediation ?? variables.patch?.remediation ?? row.review?.remediation,
      updatedAt: saved.updatedAt || saved.updated_at || row.review?.updatedAt,
    },
  };
};

export const patchVarianceReviewCaches = (queryClient, saved = {}, variables = {}) => {
  const runId = variables?.runId;
  if (!queryClient || !runId) return;
  const cachedRows = queryClient.getQueriesData({ queryKey: ['billingRecon', 'variancesAll', runId] })
    .flatMap(([, rows]) => (Array.isArray(rows) ? rows : Array.isArray(rows?.rows) ? rows.rows : []));
  const previousRow = cachedRows.find((row) => varianceIdentityMatches(row, saved, variables));
  const transitionedToReviewed = reviewedValue(saved, variables) === true && previousRow && !previousRow.reviewed;
  const patchRows = (payload) => {
    if (Array.isArray(payload)) {
      return preserveRowsMeta(payload.map((row) => patchVarianceReviewRow(row, saved, variables)), payload);
    }
    if (Array.isArray(payload?.rows)) {
      return {
        ...payload,
        rows: payload.rows.map((row) => patchVarianceReviewRow(row, saved, variables)),
      };
    }
    return payload;
  };
  queryClient.setQueriesData({ queryKey: ['billingRecon', 'variancesAll', runId] }, patchRows);
  queryClient.setQueriesData({ queryKey: ['billingRecon', 'variances', runId] }, patchRows);
  if (!transitionedToReviewed) return;
  queryClient.setQueriesData({ queryKey: ['billingRecon', 'runs'] }, (payload) => {
    const patchRun = (run) => {
      if (String(run?.id || '') !== String(runId)) return run;
      const summary = run.summary || {};
      return {
        ...run,
        summary: {
          ...summary,
          reviewed: Math.max(0, Number(summary.reviewed || 0) + 1),
          toReview: Math.max(0, Number(summary.toReview || 0) - 1),
        },
      };
    };
    if (Array.isArray(payload)) return payload.map(patchRun);
    if (Array.isArray(payload?.rows)) return { ...payload, rows: payload.rows.map(patchRun) };
    return patchRun(payload);
  });
};
